// Track a product event (AddToCart, ExpressCheckout, ...) on the Meta Pixel,
// and server-side through the Conversions API where that event is supported.

import { ProductInfo } from '../../components/product_show/ProductHero/ProductHero.types'
import { trackMetaEvent } from './trackMetaEvent'

export const trackFacebookEvent = (
  event: string,
  productInfo: ProductInfo,
  selectedPrice: string | null
) =>
  trackMetaEvent(event, {
    content_ids: [productInfo.styleCode],
    content_type: 'product_group',
    value: selectedPrice,
    currency: productInfo.displayCurrencyCode
  })
